var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ProfileImage",style:(_vm.style)},[_c('button',{staticClass:"image-change-button"},[_c('svgicon',{staticClass:"camera",attrs:{"icon":"camerasvg"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }